
export default [
  {
    path: '/admin/collateral-assets',
    name: 'collateral-asset',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/collateral-asset')
  }
]
